export default __webpack_public_path__ + "static/media/SAS Alert Tone 7.c9da25ce.wav";